(() => {
  if (window.sapBag14Loaded) return;
  window.sapBag14Loaded = true;
  const strings = JSON.parse(document.getElementById('SapBagStrings')?.textContent || '{}');
  const contexts = new WeakMap();
  const focusSelector = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let opener, activeDrawer, status;
  const inertNodes = new Map();
  const visible = node => node?.isConnected && (typeof node.checkVisibility === 'function' ? node.checkVisibility() : node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden') && !node.closest('[inert],[hidden]');
  const focusables = root => [...root.querySelectorAll(focusSelector)].filter(node => visible(node) && node.tabIndex >= 0);
  const say = text => {
    if (!status) {
      status = document.createElement('div');
      status.id = 'SapBagStatus';
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      document.body.append(status);
    }
    status.textContent = text || '';
  };
  const message = (key, values = {}) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll('__' + key.toUpperCase() + '__', value), strings[key] || '');
  function isolate(drawer, on) {
    if (!on) {
      inertNodes.forEach((wasInert, node) => { if (!wasInert) node.inert = false; });
      inertNodes.clear();
      return;
    }
    for (let node = drawer; node && node !== document.body; node = node.parentElement) {
      for (const sibling of node.parentElement?.children || []) {
        if (sibling === node || sibling === status || sibling.matches('body-element') || sibling.querySelector('body-element') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName)) continue;
        if (!inertNodes.has(sibling)) inertNodes.set(sibling, sibling.inert);
        sibling.inert = true;
      }
    }
  }
  function countName(root) {
    const data = root.querySelector('[data-bag-count]');
    const count = [...root.querySelectorAll('cart-item')].reduce((n, item) => n + Number(item.dataset.quantity || 0), 0);
    document.querySelectorAll('[data-sidebar-id="CartDrawer"]').forEach(button => {
      if (button.closest('cart-drawer')) return;
      button.setAttribute('aria-label', message('count', {count}));
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'CartDrawer');
      button.setAttribute('aria-expanded', String(!!activeDrawer?.isOpen));
    });
  }
  function labels(root) {
    root.querySelectorAll('input[name*="zip"],input[id*="Zip"],input[id*="zip"],input[id*="Postal"]').forEach(input => {
      if (!input.labels?.length) {
        if (!input.id) input.id = 'SapBagPostal-' + [...root.querySelectorAll('input')].indexOf(input);
        const label = document.createElement('label'); label.className = 'visually-hidden'; label.htmlFor = input.id; label.textContent = strings.postal || ''; input.before(label);
      }
    });
    root.querySelectorAll('quantity-btn').forEach(wrapper => { const button = wrapper.querySelector('button'); if (button && button.disabled !== wrapper.hasAttribute('disabled')) button.disabled = wrapper.hasAttribute('disabled'); });
    root.querySelectorAll('.cart-order-notes__button svg,.sap-bag-line svg').forEach(svg => svg.setAttribute('aria-hidden', 'true'));
  }
  function remember(root, target) {
    // A routine card Add on the cart page re-renders the page: remember it so focus lands on the new line, not the page top (A11y A5).
    const routine = root.matches('cart-page') && target.closest('button[name="add"]') && target.closest('.sap-bag-routine-card');
    if (routine) {
      contexts.get(root).pending = {variant: routine.querySelector('[data-product-form-variant]')?.value, index: -1, action: 'added'};
      return;
    }
    const line = target.closest('cart-item');
    const action = target.closest('[data-bag-action]')?.dataset.bagAction;
    if (!line || !action) return;
    contexts.get(root).pending = {key: line.dataset.bagKey, variant: line.dataset.variantId, index: Number(line.dataset.index), product: line.dataset.bagProduct, action};
  }
  function restore(root, announce = false) {
    if (root.matches('cart-drawer') && !root.isOpen) return;
    const context = contexts.get(root);
    if (context?.updating) return;
    const pending = context?.pending;
    if (pending) {
      const lines = [...root.querySelectorAll('cart-item')];
      const line = lines.find(item => item.dataset.bagKey === pending.key) || lines.find(item => item.dataset.variantId === pending.variant && Number(item.dataset.index) === pending.index) || lines.find(item => item.dataset.variantId === pending.variant);
      const removed = pending.action === 'remove' || (!line && pending.action === 'minus');
      const neighbour = lines[Math.min(pending.index, lines.length - 1)];
      const action = pending.action === 'upgrade' ? 'plan' : pending.action;
      let target = !removed && line?.querySelector(`[data-bag-action="${action}"]`);
      if (!target && !removed && line) target = line.querySelector('[data-bag-action="upgrade"]');
      if (!target && pending.action === 'added' && line) target = line.querySelector('[data-bag-action]') || focusables(line)[0];
      if (!target && removed) target = neighbour?.querySelector('[data-bag-action]') || root.querySelector('#SapBagTitle,.sap-system-empty__head h1');
      if (removed && target?.matches('h1,h2')) target.tabIndex = -1;
      if (visible(target) && !target.disabled) {
        target.focus({preventScroll: pending.action !== 'added'});
      }
      if (announce && !pending.announced) {
        const subtotal = root.querySelector('.cart-subtotal__totals-price,.cart-drawer-subtotal__price-current')?.textContent.replace(/Sale price/g,'').trim() || '';
        if (pending.action === 'added') { if (line) say(message('added')); }
        else if (removed) say(message('removed', {product: pending.product}));
        else if (line) {
          const plan = line.querySelector('.sap-cd-plan-select');
          say(message(['plan','upgrade'].includes(pending.action) ? 'plan' : 'quantity', {product: pending.product, quantity: line.dataset.quantity, subtotal, plan: plan ? plan.selectedOptions[0].textContent.trim() : line.querySelector('.sap-bag-line__purchase')?.textContent.trim() || ''}));
        }
        pending.announced = true;
      }
      return;
    }
    if (root.matches('cart-drawer') && root.isOpen && !root.contains(document.activeElement)) {
      (focusables(root)[0] || root).focus({preventScroll:true});
    }
  }
  // A quiet refresh (Back with a stale count while the drawer is open) notes the focused control before the remount.
  const describe = (node, root) => node && node !== root && root.contains(node) ? {node, id: node.id, key: node.closest('cart-item')?.dataset.bagKey, action: node.dataset.bagAction, name: node.getAttribute('name'), tag: node.tagName.toLowerCase()} : null;
  function settle(root, quiet) {
    const was = quiet.before, current = document.activeElement;
    // Focus goes back only if the remount dropped it; anything else is the shopper's newer choice.
    if (!was || !root.isOpen || (current && current !== document.body && current !== document.documentElement)) return;
    let target;
    if (was.key) {
      // A control on a bag line: ids follow line position, so look only inside the line with the same bag key (U1 fix 4).
      // If that line is gone, the Bag title, never another product's line.
      const line = [...root.querySelectorAll('cart-item')].find(item => item.dataset.bagKey === was.key);
      target = line && ((was.node.isConnected && line.contains(was.node) && was.node) ||
        (was.action && line.querySelector(`[data-bag-action="${was.action}"]`)) ||
        (was.name && line.querySelector(`${was.tag}[name="${CSS.escape(was.name)}"]`)));
    } else {
      // Controls outside a line, such as Check out.
      target = (was.node.isConnected && root.contains(was.node) && was.node) ||
        (was.id && root.querySelector('#' + CSS.escape(was.id))) ||
        (was.name && root.querySelector(`${was.tag}[name="${CSS.escape(was.name)}"]`));
    }
    target ||= root.querySelector('#SapBagTitle');
    if (target?.matches('h1,h2')) target.tabIndex = -1;
    if (visible(target) && !target.disabled) target.focus({preventScroll: true});
  }
  function finishUpdate(root) {
    const context = contexts.get(root);
    if (context.finishQueued) return;
    context.finishQueued = true;
    queueMicrotask(() => {
      context.finishQueued = false;
      // update-nodes runs before Aurora clears loading and completes its focus work.
      if (root.classList.contains('is-cart-loading')) return;
      const completion = context.completion;
      context.completion = null;
      context.updating = false;
      labels(root);
      countName(root);
      const quiet = context.quiet;
      context.quiet = null;
      // A quiet refresh skips restore(): no old pending action, no jump to Close (U1 fix 2). A newer shopper action wins.
      if (quiet && !context.pending) return settle(root, quiet);
      if (!completion || context.pending === completion.pending) restore(root, !!completion && !completion.error);
    });
  }
  function patch(root) {
    if (contexts.has(root)) return;
    contexts.set(root, {pending:null, updating:false, closeVersion:0, quiet:null});
    labels(root);
    root.addEventListener('focusin', event => {
      const target = event.target;
      const rail = target.closest('.sap-commerce-empty-bag__products,.sap-bag-routine__products');
      const card = target.closest('.sap-commerce-card,.sap-bag-routine-card');
      if (!rail || !card || !target.matches(':focus-visible')) return;
      const bounds = target.getBoundingClientRect(), viewport = rail.getBoundingClientRect();
      if (bounds.left < viewport.left + 4 || bounds.right > viewport.right - 4) {
        rail.scrollTo({left: rail.scrollLeft + card.getBoundingClientRect().left - viewport.left, behavior: 'instant'});
      }
    });
    root.addEventListener('pointerdown', event => {
      contexts.get(root).pending = null;
    }, true);
    root.addEventListener('click', event => {
      if (!event.target.closest('[data-bag-action]')) contexts.get(root).pending = null;
      remember(root,event.target);
    }, true);
    root.addEventListener('keydown', event => {
      if (event.key === 'Tab') contexts.get(root).pending = null;
      if (event.key === 'Enter' || event.key === ' ') remember(root,event.target);
    }, true);
    root.addEventListener('focusout', event => {
      // Remounting the drawer can briefly detach the next focus target too.
      const context = contexts.get(root);
      if (!context.updating && event.relatedTarget && event.relatedTarget !== document.body && !root.contains(event.relatedTarget)) context.pending = null;
    });
    root.addEventListener('change', event => {
      const pending = contexts.get(root).pending;
      if (!event.isTrusted && event.target.matches('[data-bag-action=quantity]') && ['plus','minus','remove'].includes(pending?.action) && event.target.closest('cart-item')?.dataset.bagKey === pending.key) return;
      remember(root,event.target);
    }, true);
    root.on?.('start-update', () => { contexts.get(root).updating = true; });
    root.on?.('update-nodes', () => {
      const context = contexts.get(root);
      context.updating = true;
      context.completion = {pending:context.pending, error:root.error};
      context.wasPlanChange = ['plan','upgrade'].includes(context.pending?.action);
      finishUpdate(root);
    });
    new MutationObserver(() => { labels(root); }).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    if (root.matches('cart-drawer')) {
      root.inert = !root.isOpen;
      const open = root.open.bind(root), hide = root.hide.bind(root);
      const setPreEmpty = root.setPreEmpty.bind(root), mount = root.mount.bind(root), setLoadingStatus = root.setLoadingStatus.bind(root);
      const handleSidebarFocusout = root.handleSidebarFocusout.bind(root);
      root.handleSidebarFocusout = function (event) {
        const context = contexts.get(this), pending = context.pending;
        if (context.updating) return;
        handleSidebarFocusout(event);
        // A late blur from the restored quantity control can run after loading
        // clears. Aurora falls back to Close; recover only that displaced action.
        const close = this.querySelector('.cart-drawer__header-close-button-wrapper');
        if (pending?.announced && ['plus','minus','quantity'].includes(pending.action) &&
            event.target.dataset.bagAction === pending.action &&
            event.target.closest('cart-item')?.dataset.bagKey === pending.key &&
            (!event.relatedTarget || event.relatedTarget === close)) {
          queueMicrotask(() => {
            const current = document.activeElement;
            if (context.pending === pending && (current === close || current === document.body || current === document.documentElement)) restore(this);
          });
        }
      };
      // The native loading cleanup is the completion hook for quantity/removal.
      root.setLoadingStatus = function (loading) {
        const result = setLoadingStatus(loading);
        if (loading) contexts.get(this).updating = true;
        else finishUpdate(this);
        return result;
      };
      root.mount = function (...args) {
        const context = contexts.get(this);
        context.updating = true;
        if (context.quiet) context.quiet.before = describe(document.activeElement, this);
        const result = mount(...args);
        finishUpdate(this);
        return result;
      };
      root.setPreEmpty = function (empty) {
        const pending = contexts.get(this).pending;
        if (empty && pending?.action === 'remove' && [...this.querySelectorAll('cart-item')].some(item => item.dataset.bagKey !== pending.key)) empty = false;
        return setPreEmpty(empty);
      };
      root.handleResize = () => {};
      root.initFocus = () => restore(root);
      root.open = function (...args) {
        const context = contexts.get(this);
        context.closeVersion++;
        if (!this.isOpen) context.pending = null;
        if (activeDrawer !== this && !this.isOpen && !this.contains(document.activeElement) && document.activeElement !== document.body) opener = document.activeElement;
        this.inert = false;
        const result = open(...args);
        activeDrawer = this;
        say('');
        isolate(this,true);
        labels(this);
        countName(this);
        restore(this);
        return result;
      };
      root.hide = function (...args) {
        const context = contexts.get(this), version = ++context.closeVersion;
        const savedOpener = opener, deadline = performance.now() + 700;
        context.pending = null;
        const result = hide(...args);
        this.inert = true;
        isolate(this,false);
        activeDrawer = null;
        countName(this);
        // Aurora may move focus back inside until its closing transition ends.
        const returnFocus = () => {
          const replacement = savedOpener?.id && document.getElementById(savedOpener.id);
          const returnTarget = visible(savedOpener) ? savedOpener : visible(replacement) ? replacement : savedOpener?.matches('[data-sidebar-id="CartDrawer"]') ? [...document.querySelectorAll('[data-sidebar-id="CartDrawer"]')].find(visible) : null;
          if (context.closeVersion !== version || this.isOpen || activeDrawer || !visible(returnTarget)) return;
          const current = document.activeElement;
          if (current !== returnTarget && current !== document.body && current !== document.documentElement && current !== document.getElementById('MainContent') && !this.contains(current)) return;
          if (current !== returnTarget) returnTarget.focus({preventScroll:true});
          if (performance.now() < deadline) requestAnimationFrame(returnFocus);
        };
        returnFocus();
        return result;
      };
      root.on?.('purchase', () => { if (!contexts.get(root).wasPlanChange) say(message('added')); contexts.get(root).wasPlanChange = false; });
      countName(root.element || root);
    }
  }
  document.addEventListener('keydown', event => {
    const drawer = activeDrawer;
    if (!drawer?.isOpen) return;
    if (event.key === 'Escape') {
      const sheet = drawer.querySelector('bottom-sheet.is-opened');
      if (sheet) return;
      event.preventDefault(); event.stopImmediatePropagation(); drawer.hide();
    } else if (event.key === 'Tab') {
      contexts.get(drawer).pending = null;
      const targets = focusables(drawer), first = targets[0], last = targets.at(-1);
      if (!first) { event.preventDefault(); drawer.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
  },true);
  document.addEventListener('focusin', event => {
    if (activeDrawer?.isOpen && !activeDrawer.contains(event.target)) restore(activeDrawer);
  });
  document.addEventListener('sap:bag-promo-updated', event => {
    const root = event.detail.root;
    if (!root?.isConnected) return;
    patch(root);
    const context = contexts.get(root);
    context.pending = null;
    context.updating = false;
    labels(root);
    countName(root);
    // After a code is applied or removed, focus the code's remove button, else Apply; never the empty field (U2 G10).
    const promo = root.querySelector('.sap-bag-promo');
    const target = promo?.querySelector('.cart-discount-code__applied-code-remove') || promo?.querySelector('[data-cart-discount-code-button]') || root.querySelector('.cart-order-notes__button[data-discount-code]');
    if (visible(target) && (!root.matches('cart-drawer') || root.isOpen)) target.focus({preventScroll:true});
    const subtotal = root.querySelector('.cart-subtotal__totals-price,.cart-drawer-subtotal__price-current')?.textContent.replace(/Sale price/g,'').trim() || '';
    say(message('promo', {subtotal}));
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sidebar-id="CartDrawer"],button[type="submit"],button[data-add-to-cart]');
    if (button && !button.closest('cart-drawer')) opener = button;
  },true);
  // Back from checkout can show a page from cached HTML rendered before the add, so the header count and the bag read the old cart (U1 G15, call B13 A).
  // Only on a back or forward visit, read /cart.js once. If a count is wrong, refresh the drawer through Aurora's own update(): it re-renders the bag and the counts without opening the drawer, and restore() above skips focus while it is closed. If it is open, the refresh is quiet: settle() above puts focus back only where the remount took it from (U1 fix 2).
  // On /cart, reload once instead; the reload is a 'reload' visit, not back_forward, so it can never repeat.
  window.addEventListener('pageshow', event => {
    if (!event.persisted && performance.getEntriesByType?.('navigation')[0]?.type !== 'back_forward') return;
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials: 'same-origin', cache: 'no-store'}).then(response => response.json()).then(cart => {
      if ([...document.querySelectorAll('cart-count')].every(node => Number(node.textContent.replace(/\D/g, '') || 0) === cart.item_count)) return;
      const drawer = document.querySelector('cart-drawer');
      if (document.querySelector('cart-page')) location.reload();
      else if (typeof drawer?.update === 'function') {
        const context = contexts.get(drawer);
        if (context && drawer.isOpen) { context.pending = null; context.quiet = {}; }
        drawer.update();
      }
    }).catch(() => {});
  });
  for (const name of ['cart-drawer','cart-page']) customElements.whenDefined(name).then(() => document.querySelectorAll(name).forEach(patch));
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('cart-drawer,cart-page').forEach(patch));
})();
